// extracted by mini-css-extract-plugin
export var container = "footer-module--container--3BV-E";